(function () {
    'use strict';

    angular.module("imApp").factory("prodBeoMethodsService", [function () {
        let service = {};

        return service;
    }]);
})();
